import { createI18n } from 'vue-i18n'
import es from './lang/es.json'
import en from './lang/en.json'
import {
  readStoredUserLocale,
  resolveDeviceLocale,
} from './resolveDeviceLocale'

export * from './resolveDeviceLocale'
export * from './useLocale'

const initialLocale = readStoredUserLocale() ?? resolveDeviceLocale()

export const i18n = createI18n({
  legacy: false,
  allowComposition: true,
  availableLocales: ['es', 'en'],
  locale: initialLocale,
  fallbackLocale: 'en',
  messages: { es, en },
})
